import DashboardService from "../../../../services/dashboard-service";
import {titleToValueForEnum} from "../widget-helpers";
import _ from "lodash";

export const reduceColumnConfig = (columnConfig) => {
    return Object.entries(columnConfig).reduce(
        (reducedColumnsConfig, [columnKey, {shown, priority}]) => ({
            ...reducedColumnsConfig,
            [columnKey]: {shown, priority},
        }),
        {}
    );
};

export const getInitalColumnsConfig = async (dataColumnsConfig, initialColumnsConfig) => {
    const columnsConfig = {};
    const columns = initialColumnsConfig;

    if (!dataColumnsConfig) {
        Object.keys(columns).forEach((column) => {
            if (columns[column].groupable) {
                columnsConfig[column] = {
                    ...columns[column],
                    shown: false,
                };
            }
        });

        return columnsConfig;
    }

    Object.keys(columns).forEach((column) => {
        if (columns[column].groupable) {
            columnsConfig[column] = {
                ...columns[column],
                shown: dataColumnsConfig[column]?.shown,
                priority: dataColumnsConfig[column]?.priority,
            };
        }
    });

    return columnsConfig;
};

export const getInitialColumnsConfig = getInitalColumnsConfig;

export const getFilterColumnsConfig = (initialColumnsConfig) => {
    const filterColumnsConfig = {};
    const columns = initialColumnsConfig;

    Object.keys(columns).forEach((column) => {
        filterColumnsConfig[column] = {
            ...columns[column],
        };
    });

    return filterColumnsConfig;
};

const getSingleLabelFilterParams = (dataItem, dataInventoryItems) => {
    const params = [];
    const firstLevel = dataItem;
    let firstLevelItem = firstLevel.name;

    if (dataItem.parent !== "0") {
        const secondLevel = dataInventoryItems.find((item) => item.id === dataItem.parent);
        let secondLevelItem = secondLevel.name;

        if (secondLevel.parent !== "0") {
            const thirdLevel = dataInventoryItems.find((item) => item.id === secondLevel.parent);
            let thirdLevelItem = thirdLevel.name;

            if (thirdLevel.cfQuery) {
                const objectKey = Object.keys(thirdLevel.cfQuery)[0];
                thirdLevelItem = thirdLevel.cfQuery[objectKey];
            }

            params.push(thirdLevelItem);
        }

        if (secondLevel.cfQuery) {
            const objectKey = Object.keys(secondLevel.cfQuery)[0];
            secondLevelItem = secondLevel.cfQuery[objectKey];
        }

        params.push(secondLevelItem);
    }

    if (firstLevel.cfQuery) {
        const objectKey = Object.keys(firstLevel.cfQuery)[0];
        firstLevelItem = firstLevel.cfQuery[objectKey];
    }

    params.push(firstLevelItem);
    return params;
};

const isCustomField = (input) => {
    return input.match(
        "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
    );
};

export const getSingleLabelRedirectFilter = (
    dataItem,
    dataInventoryItems,
    selectedFields,
    eqParams,
    columnsConfig = {}
) => {
    const params = getSingleLabelFilterParams(dataItem, dataInventoryItems).map((item, index) => {
        const rawSelectedField = selectedFields[index];
        let selectedField = rawSelectedField;

        if (isCustomField(selectedField)) {
            selectedField = `customFieldValues.${selectedField}`;
        }

        if (selectedField === "licensed") {
            const licensedState = item === "true" ? true : false;
            return {[selectedField]: licensedState};
        }

        const filterValue = titleToValueForEnum(
            item,
            _.get(columnsConfig, [rawSelectedField, "options"])
        );

        const filterItem = {[selectedField]: {$eq: filterValue}};

        return filterItem;
    });

    const filter = {$and: params};

    return filter;
};
